import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const ClientNameLabel = ({name}) => {

    return (
        <div className="d-flex flex-row align-items-center justify-content-center">
            <FontAwesomeIcon color="#8884d8" icon="address-card"/>
            <p className="font-weight-light p-0 m-0 pl-2">{name}</p>
        </div>
    )

}

ClientNameLabel.propTypes = {
    name: PropTypes.string.isRequired
}

export default ClientNameLabel